import * as React from 'react';
import { createContext } from 'react';
import { type ModeContextType } from './types';

export const ModeContext: React.Context<ModeContextType> =
  createContext<ModeContextType>({ mode: undefined });

export const ModeContextProvider = ({
  mode,
  children,
}: {
  children: any;
  mode: any | undefined;
}): React.ReactNode => {
  return (
    <ModeContext.Provider
      value={{
        mode,
      }}
    >
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = (): ModeContextType => {
  return React.useContext(ModeContext);
};
